var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{staticClass:"ticketDialog",style:({height: '95%'}),attrs:{"visible":_vm.ticketDialogVisible,"width":"27rem","align":"left","top":"2.5%"},on:{"close":_vm.closeDialog,"visible-change":_vm.closeDialog,"update:visible":_vm.closeDialog}},[_c('span',{staticClass:"monospace p-0",domProps:{"innerHTML":_vm._s(_vm.ticketCode)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }